import { topicPartRepository } from "../../../providers/repositories/topicPartRepository";
import { TopicPart, TopicPartFormData } from "../entities/TopicPart";
import { toast } from "react-toastify";
import { t } from "i18next";
import Logger from "../../../utils/Logger";

export const addUpdateTopicPartUseCase = {
    async exec(
        data: TopicPartFormData,
        id: number | string | null,
    ): Promise<TopicPart | null> {
        try {
            const topicPart = await topicPartRepository.addUpdate(data, id);

            if (id) {
                toast.success(t("action.updateSuccess"));
            }
            return topicPart;
        } catch (error) {
            Logger.error("updateTopicPartUseCase", error);
            toast.error(t("action.updateError"));
        }

        return null;
    },
};
